import { defineMessages } from "react-intl";

export const extraCategoryInputsMessages = defineMessages({
  category: {
    id: "extrasCategories.extraForm.category",
    defaultMessage: "Category",
  },
  categoryUnsupportedHelp: {
    id: "extrasCategories.extraForm.categoryUnsupportedHelp",
    defaultMessage: "Only available for per unit & stay or per unit & night extras",
  },
  vehicleType: {
    id: "extrasCategories.extraForm.vehicleType",
    defaultMessage: "Vehicle type",
  },
  vehicleTypePlaceholder: {
    id: "extrasCategories.extraForm.vehicleTypePlaceholder",
    defaultMessage: "Select…",
  },
  requestLicensePlate: {
    id: "extrasCategories.extraForm.requestLicensePlate",
    defaultMessage: "Request licence plate per unit",
  },
});
